'use strict';

require('setimmediate');
var OCL = require('openchemlib');

require('./extend')(OCL);

module.exports = OCL;


// WEBPACK FOOTER //
// ./lib/index.js